module.exports = __webpack_public_path__ + "img/plus.7ab31b39.svg";